<logibids-user-headers />

<div class="main_wrp relative">
  <div class="card_view" #modulesWrapper>
    <router-outlet />
  </div>

  @if (infographicsService.showAvailableVehicleInfo()) {
    <logibids-available-vehicle-info />
  }
  @if (infographicsService.showTransportInqInfo()) {
    <logibids-transport-inq-info class="infographics_wrapper" />
  }
  @if (infographicsService.showPostEnqInfographics()) {
    <logibids-post-enq-infographics class="infographics_wrapper" />
  }

  @defer (when isBrowser; on viewport) {
    @if (!isTrackingRoute()) {
      <logibids-google-map> </logibids-google-map>
    } @else {
      <logibids-tracking-map></logibids-tracking-map>
    }
  } @placeholder {
    <div></div>
  }

  @if (isBrowser) {
    <logibids-map-widgets />
  }
</div>

@if (isBrowser) {
  <p-toast />
  <div class="confirm-dilouge">
    <p-confirmDialog [defaultFocus]="'none'" />
  </div>
}

@if (aiOpen() && isBrowser && accessToken()) {
  <logibids-ai-cab-booking />
}
